import { AloBaseLg, getDefaultAloBaseLg } from "./AloBaseLg"


export interface AloAllergeneLg extends AloBaseLg  {        
}

export const getDefaultAloAllergeneLg = ():AloAllergeneLg => {
    return {
        ...getDefaultAloBaseLg("en")
    }
}